import { useEffect, useRef, useState } from 'react'

// A delivered reply keeps its turn until the deferred-answer check settles: shown answered, Send off.
export function useGretaAIChatReplySettle({
  activeChatId,
  getIsOpenConversation,
}) {
  const settlingChatIdsRef = useRef(new Set())

  const [isReplySettling, setIsReplySettling] = useState(false)

  // Re-syncs on chat switch so another chat's settle doesn't block this composer.
  useEffect(() => {
    setIsReplySettling(settlingChatIdsRef.current.has(activeChatId))
  }, [activeChatId])

  function startReplySettle(conversationId) {
    settlingChatIdsRef.current.add(conversationId)

    if (getIsOpenConversation(conversationId)) {
      setIsReplySettling(true)
    }
  }

  function endReplySettle(conversationId) {
    settlingChatIdsRef.current.delete(conversationId)

    if (getIsOpenConversation(conversationId)) {
      setIsReplySettling(false)
    }
  }

  function getIsReplySettling(conversationId) {
    return settlingChatIdsRef.current.has(conversationId)
  }

  return {
    endReplySettle,
    getIsReplySettling,
    isReplySettling,
    startReplySettle,
  }
}
